export class ListAzureVirtualNetworks200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "virtualNetworks",
            "baseName": "virtualNetworks",
            "type": "Array<ListAzureVirtualNetworks200ResponseVirtualNetworksInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureVirtualNetworks200Response.attributeTypeMap;
    }
    constructor() {
    }
}
